export default __webpack_public_path__ + "static/media/settings_selected.f459700b.svg";